import {newStepValue} from '../../../../services/flowBuilder/utils/constants';

export const switchCase = {
    json: {
        action: {
            name: '',
            description: '',
            actionType: 'switchCase',
            actionParams: {
                variable: '',
                isCaseSensitive: false,
            },
            result: {
                '[Value]': newStepValue,
                other: newStepValue,
            },
        },
        type: 'action',
    },
    paths: [
        'action.name',
        'action.description',
        'action.actionParams.variable',
        'action.actionParams.isCaseSensitive',
        'action.result.#',
    ],
    groups: [
        {
            Parameters: [
                'action.name',
                'action.description',
                'action.actionParams.variable',
                'action.actionParams.isCaseSensitive',
            ],
        },
        {
            Logic: [
                'action.result.#',
            ],
        },
    ],
    layout: {
        name: {
            type: 'text',
            label: 'Name',
            validators: {
                required: true,
                spaceOnName: true,
            },
        },
        description: {
            type: 'text',
            label: 'Description',
            validators: {
                required: true,
            },
        },
        variable: {
            type: 'text',
            label: 'Variable',
            validators: {
                required: true,
            }
        },
        isCaseSensitive: {
            type: 'checkbox-single',
            label: 'Case Sensitive',
        },
        result: {
            dataType: 'keyValue',
            attributes: {
                add: true,
                delete: true,
            },
            label: 'Result',
            key: {
                type: 'text',
                label: '',
            },
            value: {
                type: 'next',
                label: 'Point to',
            },
        },
        other : {
            dataType: 'keyValue',
            key: {
                attributes: {
                    readonly: true,
                },
                type: 'text',
                label: '#',
            },
            next: {
                type: 'next',
                label: 'Point to',
            },
        },
    },
};
